import { ParentNavigationItem } from "./types";

/**
 * Checks if a navigation item has sub-items
 */
export const hasSubItems = (item: ParentNavigationItem): boolean => {
  return item.subItems !== undefined && item.subItems.length > 0;
};

/**
 * Checks if the current path matches the given path
 * @param path - The path to check against
 * @param currentPath - The current pathname from location
 */
export const isActiveRoute = (path: string, currentPath: string): boolean => {
  return currentPath === path;
};
